//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'ProgressCircle',

	props: {
		percent: {
			type: Number,
			required: true,
		},

		backgroundColor: {
			type: String,
			required: false,
			default: 'text-background-form',
		},

		size: {
			type: String,
			required: false,
			default: 'sm',
		},
	},

	data() {
		return {
			availableSizes: ['sm', 'lg'],
		};
	},

	computed: {
		circumference() {
			return this.radius * 2 * Math.PI;
		},

		coordinate() {
			return {
				sm: 30,
				lg: 50,
			}[this.size];
		},

		dimensions() {
			return {
				sm: 'w-16 h-16',
				lg: 'w-24 h-24',
			}[this.size];
		},

		radius() {
			return {
				sm: 23,
				lg: 40,
			}[this.size];
		},

		stroke() {
			return {
				sm: 3,
				lg: 5,
			}[this.size];
		},

		textColor() {
			if (this.percent >= 100) return 'text-success';

			if (this.percent >= 75) return 'text-primary';

			if (this.percent > 25 && this.percent < 75) return 'text-warning';

			return 'text-error';
		},

		textMargin() {
			return {
				sm: 'mt-1',
				lg: 'mt-3 ml-1.5',
			}[this.size];
		},

		textSize() {
			return {
				sm: 'text-sm',
				lg: 'font-bold text-lg',
			}[this.size];
		},
	},

	created() {
		if (!this.availableSizes.includes(this.size)) {
			throw Error('Invalid progress circle size provided.');
		}
	},
};
